// Product Tabs Functionality
document.addEventListener('DOMContentLoaded', function() {
  const tabsContainer = document.querySelector('.product-tabs');
  
  if (tabsContainer) {
    const tabButtons = tabsContainer.querySelectorAll('.product-tabs__tab:not(.product-tabs__tab--link)');
    const tabLinks = tabsContainer.querySelectorAll('.product-tabs__tab--link');
    const tabPanels = tabsContainer.querySelectorAll('.product-tabs__panel');
    const tabsHeader = tabsContainer.querySelector('.product-tabs__header');
    
    // Helper function to scroll tab into view
    function scrollTabIntoView(tab) {
      if (!tabsHeader || !tab) return;
      
      const headerRect = tabsHeader.getBoundingClientRect();
      const tabRect = tab.getBoundingClientRect();
      
      // Calculate scroll position to center the tab
      const scrollLeft = tabsHeader.scrollLeft + (tabRect.left - headerRect.left) - (headerRect.width / 2) + (tabRect.width / 2);
      
      tabsHeader.scrollTo({
        left: scrollLeft,
        behavior: 'smooth'
      });
    }
    
    // Activate first tab on load
    if (tabButtons.length > 0 && tabPanels.length > 0) {
      // Find first non-link tab
      const firstTab = tabButtons[0];
      const firstPanel = tabPanels[0];
      
      if (firstTab && firstPanel) {
        firstTab.classList.add('active');
        firstPanel.classList.add('active');
        scrollTabIntoView(firstTab);
      }
    }
    
    // Helper function to activate a tab
    function activateTab(button) {
      const targetTab = button.getAttribute('data-tab');
      
      // Remove active from all
      tabButtons.forEach(btn => btn.classList.remove('active'));
      tabLinks.forEach(link => link.classList.remove('active'));
      tabPanels.forEach(panel => panel.classList.remove('active'));
      
      // Add active to clicked tab
      button.classList.add('active');
      const targetPanel = tabsContainer.querySelector(`#${targetTab}`);
      if (targetPanel) {
        targetPanel.classList.add('active');
      }
      
      // Scroll tab into view
      scrollTabIntoView(button);
    }
    
    // Add click handlers for regular tabs
    tabButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        activateTab(this);
      });
    });
    
    // Add click handlers for link tabs (scroll to section)
    tabLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        const sectionId = this.getAttribute('data-scroll-to');
        const targetSection = document.getElementById(sectionId);
        
        if (targetSection) {
          // Remove active from all tabs
          tabButtons.forEach(btn => btn.classList.remove('active'));
          tabLinks.forEach(lnk => lnk.classList.remove('active'));
          tabPanels.forEach(panel => panel.classList.remove('active'));
          
          // Add active to clicked link
          this.classList.add('active');
          
          // Scroll tab into view
          scrollTabIntoView(this);
          
          // Smooth scroll to section
          targetSection.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'start' 
          });
        }
      });
    });
  }
});
